*,
*::before,
*::after {
  box-sizing: border-box;
}

:host {
  --wui-textarea-clear-color: var(--wui-color-text-tertiary, rgb(27 27 27 / 0.35));
  display: block;
}

:host([disabled]) {
  cursor: not-allowed;
  opacity: 0.4;
}

/* ===== Textarea ===== */

.wui-textarea-inner {
  position: relative;

  display: flex;
  gap: 8px;
  align-items: flex-start;

  box-sizing: border-box;
  width: var(--wui-textarea-width, 200px);
  min-width: var(--wui-control-size, 40px);
  padding: 9px 12px;
  border-radius: 20px;

  transition:
    border-color var(--wui-duration-focus, 200ms),
    box-shadow var(--wui-duration-focus, 200ms);
}

:host([full]) .wui-textarea-inner {
  width: 100%;
}

/* ===== Borderless ===== */

:host([borderless]) .wui-textarea-inner {
  padding: 9px 0;
  border: none;

  background: transparent;
  backdrop-filter: none;
  box-shadow: none;
}

:host([focused]) .wui-textarea-inner {
  --wui-internal-glass-focus-ring:
    inset 0 0 0 1px var(--wui-color-accent, #08f),
    0 0 0 var(--wui-focus-ring-width, 3px) var(--wui-color-focus-ring, rgb(0 136 255 / 0.4));
}

:host([borderless][focused]) .wui-textarea-inner {
  border-color: transparent;

  /* borderless 移除了背景和玻璃阴影，但仍必须保留可感知的键盘/输入焦点边界 */
  outline: var(--wui-focus-ring-width, 3px) solid var(--wui-color-focus-ring, rgb(0 136 255 / 0.4));
  outline-offset: 2px;
}

textarea {
  resize: vertical;

  display: block;
  flex: 1;

  box-sizing: border-box;
  width: 100%;
  margin: 0;
  padding: 0;
  border: none;

  /* 表单控件不继承字体；显式继承以对齐宿主排版，避免 UA 默认字体差异 */
  font: inherit;
  font-size: var(--wui-font-size, 14px);
  line-height: 1.5;
  color: var(--wui-color-text, #1b1b1b);

  background: transparent;
  outline: none;

  &::placeholder {
    color: var(--wui-color-text-secondary, #6a6a6a);
  }

  &:disabled {
    cursor: not-allowed;
  }

  &:read-only {
    cursor: default;
  }
}

/* ===== Prefix / Suffix ===== */

slot {
  display: flex;
  flex-shrink: 0;
  align-items: center;

  font-size: var(--wui-font-size, 14px);
  color: var(--wui-color-text-secondary, #6a6a6a);
}

slot.empty {
  display: none;
}

/* ===== Clear button ===== */

/* 复用 web-ui-button icon ghost：仅覆盖颜色为 faint 并对齐首行，保持弱意图清除图标观感；
   负 margin-left 抵消容器 8px flex gap，让清除按钮紧贴文本域内容 */
.wui-textarea-inner web-ui-button[variant='ghost'] {
  --wui-button-color: var(--wui-textarea-clear-color);

  /* 与首行文字垂直居中对齐：容器 align-items: flex-start 使按钮贴内容区顶部（9px 留白处），
     而首行中心在 9px + 行高半程；要让 24px 按钮（18px 图标居中）的图标中心落在首行中心，
     需上移 (行高 − 按钮高度) / 2，行高 = font-size × 1.5（与 textarea 的 line-height 一致） */
  margin-top: calc((var(--wui-font-size, 14px) * 1.5 - 24px) / 2);
  margin-left: -8px;
}
